var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataUnavailableStandard = function SvgDataUnavailableStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 248,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.314 10.313C135.655 1.273 151.888-.579 166.665.14c46.41 2.267 87.827 17.99 124.065 42.88 13.12 9.008 26.512 24.996 35.026 37.405 17.348 25.258 12.193 60.248-11.91 81.056-8.202 7.079-18.143 12.516-28.35 17.318-18.148 8.553-37.73 15.42-58.327 17.383-14.685 1.391-29.555.261-44.158-1.682-40.795-5.445-80.833-17.46-114.406-38.015-14.72-9.015-28.595-20.224-34.663-34.802-6.068-14.578-2.184-33.074 12.848-41.72 6.217-3.571 13.651-5.184 20.927-6.7 10.713-2.229 21.596-4.426 31.26-8.956 9.988-4.68 21.809-13.73 19.826-24.09-2.11-11.102-3.816-20.864 6.511-29.904Z",
    fill: "#37A3BC",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 219.6s8.482-14.907 21.253-19.202a26.126 26.126 0 0 0 13.241-9.826 43.398 43.398 0 0 0 3.906-6.972",
    stroke: "#535461",
    strokeWidth: 0.666
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.856 181.795c-1.495 1.48-8.456 3.005-8.456 3.005s1.706-7.039 3.201-8.515a3.724 3.724 0 0 1 5.333.08 3.89 3.89 0 0 1-.078 5.43ZM312.481 191.958c-2.089.389-8.881-2.028-8.881-2.028s5.307-4.66 7.393-5.06c2.088-.389 4.117.882 4.532 2.84.415 1.957-.941 3.859-3.03 4.248h-.014ZM298.308 206.174c-2.052-.664-6.708-5.947-6.708-5.947s7.236-1.516 9.277-.864c1.354.4 2.367 1.442 2.647 2.724.279 1.282-.219 2.602-1.302 3.45-1.082.849-2.58 1.092-3.914.637ZM284.713 213.546c-2.086-.332-7.513-4.824-7.513-4.824s6.673-2.62 8.759-2.294c1.36.2 2.502 1.07 2.991 2.283.49 1.212.25 2.578-.626 3.578s-2.255 1.48-3.611 1.257ZM297.6 185.002c0 2.105 3.597 8.198 3.597 8.198s3.603-6.093 3.603-8.194c0-2.102-1.612-3.806-3.6-3.806s-3.6 1.704-3.6 3.806v-.004ZM282.167 194.702c.6 2.07 5.783 6.898 5.783 6.898s1.721-7.176 1.124-9.246c-.598-2.07-2.628-3.222-4.536-2.573-1.907.648-2.97 2.852-2.371 4.921ZM270.033 205.938c.265 2.096 4.61 7.662 4.61 7.662s2.805-6.586 2.54-8.681c-.266-2.096-2.082-3.566-4.056-3.284-1.974.281-3.36 2.208-3.094 4.303Z",
    fill: "#37A3BC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.856 181.795c-1.495 1.48-8.456 3.005-8.456 3.005s1.706-7.039 3.201-8.515a3.724 3.724 0 0 1 5.333.08 3.89 3.89 0 0 1-.078 5.43ZM312.481 191.958c-2.089.389-8.881-2.028-8.881-2.028s5.307-4.66 7.393-5.06c2.088-.389 4.117.882 4.532 2.84.415 1.957-.941 3.859-3.03 4.248h-.014ZM298.308 206.174c-2.052-.664-6.708-5.947-6.708-5.947s7.236-1.516 9.277-.864c1.354.4 2.367 1.442 2.647 2.724.279 1.282-.219 2.602-1.302 3.45-1.082.849-2.58 1.092-3.914.637ZM284.713 213.546c-2.086-.332-7.513-4.824-7.513-4.824s6.673-2.62 8.759-2.294c1.36.2 2.502 1.07 2.991 2.283.49 1.212.25 2.578-.626 3.578s-2.255 1.48-3.611 1.257ZM297.6 185.002c0 2.105 3.597 8.198 3.597 8.198s3.603-6.093 3.603-8.194c0-2.102-1.612-3.806-3.6-3.806s-3.6 1.704-3.6 3.806v-.004ZM282.167 194.702c.6 2.07 5.783 6.898 5.783 6.898s1.721-7.176 1.124-9.246c-.598-2.07-2.628-3.222-4.536-2.573-1.907.648-2.97 2.852-2.371 4.921ZM270.033 205.938c.265 2.096 4.61 7.662 4.61 7.662s2.805-6.586 2.54-8.681c-.266-2.096-2.082-3.566-4.056-3.284-1.974.281-3.36 2.208-3.094 4.303Z",
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 220.8s1.665-17.336 11.587-26.554a26.456 26.456 0 0 0 8.089-14.559c.487-2.667.73-5.375.724-8.087",
    stroke: "#535461",
    strokeWidth: 0.666
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.104 165.15c-.741 2.035-6.222 6.45-6.222 6.45s-1.178-7.387-.437-9.419c.457-1.352 1.54-2.323 2.831-2.537 1.29-.214 2.584.363 3.38 1.507.795 1.144.967 2.675.448 3.999ZM298.34 178.42c-1.766 1.193-9.14 1.58-9.14 1.58s2.883-6.524 4.638-7.716a4.052 4.052 0 0 1 3.896-.336c1.267.564 2.125 1.733 2.25 3.068s-.502 2.633-1.644 3.404ZM290.515 194.394c-2.111.166-8.515-2.942-8.515-2.942s5.774-4.07 7.86-4.24c2.102-.166 3.95 1.306 4.126 3.29.177 1.982-1.383 3.725-3.485 3.892h.014ZM282.63 207.522c-2.067.498-9.03-1.544-9.03-1.544s5.021-4.945 7.088-5.443c1.347-.354 2.794 0 3.783.925.988.925 1.364 2.276.982 3.533-.382 1.256-1.462 2.222-2.823 2.525v.004ZM282.282 176.668c.804 1.848 6.442 5.732 6.442 5.732s.96-6.838.153-8.686c-.83-1.806-2.932-2.607-4.73-1.8-1.796.806-2.625 2.923-1.865 4.76v-.006ZM272.227 190.903c1.436 1.513 8.573 3.497 8.573 3.497s-1.204-6.8-2.644-8.312c-.923-1.005-2.36-1.472-3.76-1.221-1.4.25-2.545 1.18-2.995 2.431-.45 1.252-.134 2.63.826 3.605ZM264.588 206.204c1.142 1.794 7.812 4.996 7.812 4.996s.054-7.19-1.091-8.985c-.739-1.16-2.061-1.85-3.47-1.814-1.41.038-2.692.798-3.363 1.995a3.696 3.696 0 0 0 .108 3.808h.004Z",
    fill: "#37A3BC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    opacity: 0.1,
    cx: 244.2,
    cy: 217.2,
    rx: 40.2,
    ry: 7.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B77B7F",
    fillRule: "nonzero",
    d: "m247.2 128.604-.036 1.326-2.225 81.27H241.2l1.833-81.27.036-1.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDA2A6",
    fillRule: "nonzero",
    d: "m268.8 195.6-2.883-.006-42.834-.086-2.283-.003 1.216-3.505h46.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1,
    d: "m246 128.56-.042 1.04H241.2l.042-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B77B7F",
    fillRule: "nonzero",
    d: "M241.2 126h7.2v2.4h-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1,
    d: "m223.2 192-.342 3.6-2.058-.003 1.096-3.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDA2A6",
    fillRule: "nonzero",
    d: "m229.2 126-.122 1.15-9.792 92.45-4.486-.204 10.32-92.246.114-1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1,
    d: "m268.8 195.6-3.171-.006L265.2 192h3.265z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDA2A6",
    fillRule: "nonzero",
    d: "m273.6 219.396-4.49.204-9.788-92.45-.122-1.15 3.962.1.115 1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M195.6 34.8h94.8V126h-94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.798 4.339V26.4h-3.596V4.339a1.875 1.875 0 0 1 .876-1.677 1.75 1.75 0 0 1 1.844 0c.568.35.904.994.876 1.677Z",
    fill: "#DDA2A6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1,
    d: "M241.2 25.2h3.6v2.4h-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.4 26.128V33.6h-7.2v-7.472a.898.898 0 0 1 .287-.657c.185-.174.436-.272.698-.271h5.238c.54.004.977.418.977.928Z",
    fill: "#DDA2A6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1,
    cx: 242.4,
    cy: 30,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B77B7F",
    fillRule: "nonzero",
    cx: 242.4,
    cy: 30,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1,
    d: "M241.2 32.4h7.2v1.2h-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1,
    d: "M237.6 32.4h12v2.4h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDA2A6",
    fillRule: "nonzero",
    d: "M237.6 32.4h12v2.4h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.392 124.8h50.816c1.21 0 2.192.882 2.192 1.97v.43h-55.2v-.43c0-1.088.982-1.97 2.192-1.97Z",
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1,
    d: "M225.702 126.105 229.2 126l-.108 1.2H225.6zM241.2 126h7.2v1.2h-7.2zM262.8 127.2h-3.492l-.108-1.2 3.498.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.392 124.8h50.816c1.21 0 2.192.882 2.192 1.97v.43h-55.2v-.43c0-.523.231-1.024.642-1.393.411-.37.969-.577 1.55-.577Z",
    fill: "#DDA2A6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.465 169.2s2.644 3.082-1.22 7.729S24.2 185.5 25.493 188.4c0 0 5.825-8.633 10.569-8.754 4.744-.12 1.621-5.252-3.597-10.446Z",
    fill: "#37A3BC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.945 169.2c.213.3.38.63.497.976 4.255 4.843 6.521 9.36 2.431 9.475-3.808.104-8.378 6.703-9.473 8.368.035.13.079.257.131.381 0 0 5.356-8.63 9.718-8.75 4.362-.12 1.495-5.259-3.304-10.45Z",
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.564 173.432c0 .981-.125 1.768-.28 1.768-.156 0-.284-.796-.284-1.768 0-.973.159-.519.314-.519s.25-.474.25.519Z",
    fill: "#FFD037",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.828 174.607c-.935.42-1.753.677-1.823.568-.07-.108.64-.529 1.567-.957.926-.428.567-.113.64 0 .075.114.552-.034-.384.389Z",
    fill: "#FFD037",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.138 169.2s-2.641 3.082 1.218 7.729c3.86 4.647 7.036 8.571 5.756 11.471 0 0-5.836-8.633-10.578-8.754-4.742-.12-1.609-5.252 3.604-10.446Z",
    fill: "#37A3BC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.663 169.2c-.213.3-.38.63-.497.976-4.25 4.843-6.514 9.36-2.428 9.475 3.803.104 8.385 6.703 9.462 8.368a3.632 3.632 0 0 1-.127.381s-5.367-8.63-9.728-8.75c-4.36-.12-1.476-5.259 3.318-10.45Z",
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4 173.432c0 .981.125 1.768.28 1.768.156 0 .284-.796.284-1.768 0-.973-.159-.519-.314-.519s-.25-.474-.25.519ZM12.57 174.607c.938.42 1.751.677 1.825.568.073-.108-.64-.529-1.568-.957-.928-.428-.567-.113-.64 0-.074.114-.55-.034.384.389Z",
    fill: "#FFD037",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    opacity: 0.1,
    cx: 25.8,
    cy: 210.6,
    rx: 25.8,
    ry: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.394 185.092-.122 1.01-.173 1.404-.07.585-.174 1.408-.074.586-.173 1.404-1.96 15.972C35.47 208.89 33.125 210 30.29 210H20.11c-2.835 0-5.178-1.111-5.355-2.539l-1.963-15.976-.173-1.404-.071-.586-.176-1.407-.072-.586-.173-1.404-.122-1.01c-.098-.808 1.17-1.488 2.774-1.488h20.862c1.583.003 2.855.683 2.753 1.492Z",
    fill: "#65617D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D9CB5",
    fillRule: "nonzero",
    d: "m38.4 186-.163 1.2H13.363L13.2 186zM38.4 187.2l-.166 1.2H13.37l-.17-1.2zM38.4 189.6l-.173 1.2H13.373l-.173-1.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    opacity: 0.1,
    cx: 63,
    cy: 45,
    r: 10.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    opacity: 0.1,
    cx: 40.2,
    cy: 19.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37A3BC",
    fillRule: "nonzero",
    opacity: 0.1,
    cx: 6.6,
    cy: 35.4,
    r: 4.2
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontSize: 20,
    fontWeight: 500,
    fill: "#000",
    fillOpacity: 0.25
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 91,
    y: 124
  }, "Data Unavailable")))));
};
export default SvgDataUnavailableStandard;